import { auth } from "./state";

const init = ({ dispatch }) => {
    dispatch("validate");
};

const validate = ({ commit, state }) => {
    if (!state.currentUser) return Promise.resolve(null);
    const user = auth.currentUser();
    commit("SET_CURRENT_USER", user);
    return user;
};

const attemptLogin = ({ commit, dispatch }, credentials) => {
    return new Promise((resolve, reject) => {
        dispatch("attemptConfirmation", credentials).then(() => {
            auth
                .login(credentials.email, credentials.password, true)
                .then(response => {
                    resolve(response);
                    commit("SET_CURRENT_USER", response);
                })
                .catch(error => {
                    reject(error.json);
                });
        });
    });
};

const attemptConfirmation = ({ commit, dispatch }, credentials) => {
    return new Promise((resolve, reject) => {
        if (!credentials.token) {
            resolve();
            return;
        }
        auth
            .confirm(credentials.token, true)
            .then(response => {
                credentials.token = null;
                dispatch("attemptLogin", credentials);
                resolve(response);
            })
            .catch(error => {
                reject(error);
                console.error(error);
            });
    });
};

const attemptSignUp = ({ commit }, credentials) => {
    return new Promise((resolve, reject) => {
        auth
            .signup(credentials.email, credentials.password)
            .then(response => {
                commit("TOGGLE_LOAD");
                resolve(response);
            })
            .catch(error => {
                reject(error);
                console.error("It's an error", error);
            });
    });
};

const attemptLogout = ({ commit }) => {
    return new Promise((resolve, reject) => {
        const user = auth.currentUser();
        user
            .logout()
            .then(response => {
                resolve(response);
                commit("SET_CURRENT_USER", null);
            })
            .catch(error => {
                reject(error);
                console.error("Could not log out", error);
            });
    });
};

const attemptRecoveryRequest = ({ commit, dispatch }, credentials) => {
    return new Promise((resolve, reject) => {
        if (!credentials.email) {
            resolve();
            return;
        }
        auth
            .requestPasswordRecovery(credentials.email)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
                console.error(error);
            });
    });
};

const attemptRecovery = ({ commit, dispatch }, credentials) => {
    return new Promise((resolve, reject) => {
        if (!credentials.token) {
            resolve();
            return;
        }

        auth
            .recover(credentials.token, false)
            .then(response => {
                credentials.token = null;
                commit("SET_CURRENT_USER", response);
                resolve(response);
            })
            .catch(error => {
                reject(error);
                console.error(error);
            });
    });
};

const attemptUpdatePassword = ({ commit }, credentials) => {
    return new Promise((resolve, reject) => {
        if (!credentials.password) {
            resolve();
            return;
        }
        const user = auth.currentUser();
        user
            .update({ password: credentials.password })
            .then(response => {
                resolve(response);
                commit("SET_CURRENT_USER", response);
            })
            .catch(error => {
                reject(error);
                console.error("Could not update password", error);
            });
    });
};

const addNotification = ({ commit }, notification) => {
    commit("ADD_NOTIFICATION", notification);
};

const removeNotification = ({ commit }, notification) => {
    commit("REMOVE_NOTIFICATION", notification);
};

const addSidebarChild = ({ commit }, child) => {
    commit("ADD_SIDEBARCHILD", child);
};

export default {
    init,
    validate,
    attemptSignUp,
    attemptConfirmation,
    attemptLogin,
    attemptLogout,
    attemptRecovery,
    attemptUpdatePassword,
    attemptRecoveryRequest,
    addNotification,
    removeNotification,
    addSidebarChild
};